{
  "version": 1,
  "asset_id": "05e8834f-62fa-4440-ab0c-ea2161a37107",
  "project_id": "288ffafd-b4ec-4687-a58e-f3a6c56e4541",
  "url": "/__l5e/assets-v1/05e8834f-62fa-4440-ab0c-ea2161a37107/home-vloot-wagens.jpg",
  "r2_key": "a/v1/288ffafd-b4ec-4687-a58e-f3a6c56e4541/05e8834f-62fa-4440-ab0c-ea2161a37107/home-vloot-wagens.jpg",
  "original_filename": "home-vloot-wagens.jpg",
  "size": 2970668,
  "content_type": "image/jpeg",
  "created_at": "2026-08-31T21:19:12Z"
}
